var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoorDataArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5087 10.9636L21.6043 0.490909C21.2636 0.163636 20.8092 0 20.2981 0H2.06739C1.04511 0 0.25 0.763636 0.25 1.74545V40.2545C0.25 41.2364 1.04511 42 2.06739 42H31.2024C32.2247 42 33.0198 41.2364 33.0198 40.2545V12.2182C33.0766 11.7273 32.9062 11.2909 32.5087 10.9636ZM22.1155 5.94545L26.8293 10.4727H22.1155V5.94545ZM14.8459 3.43636C16.8337 3.43636 18.4807 5.01818 18.4807 6.92727V12.2182C18.4807 13.2 19.2758 13.9636 20.2981 13.9636H29.3851V38.4545H3.88478V3.43636H14.8459Z",
    fill: "#DEE2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1076 26.1818L8.0875 31.9636C7.34919 32.6727 7.34919 33.7636 8.0875 34.4182C8.82582 35.1273 9.96169 35.1273 10.6432 34.4182L16.6633 28.6909L22.6834 34.4727C23.4217 35.1818 24.5576 35.1818 25.2391 34.4727C25.9774 33.7636 25.9774 32.6727 25.2391 32.0182L19.219 26.1818L25.2391 20.4C25.9774 19.6909 25.9774 18.6 25.2391 17.9455C24.5008 17.2364 23.3649 17.2364 22.6834 17.9455L16.6633 23.7273L10.6432 17.9455C9.90489 17.2364 8.76902 17.2364 8.0875 17.9455C7.34919 18.6545 7.34919 19.7455 8.0875 20.4L14.1076 26.1818Z",
    fill: "#DEE2E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoorDataArea);
export default __webpack_public_path__ + "static/media/poorDataArea.902aba46aa2bd6fcf742b997c154bc80.svg";
export { ForwardRef as ReactComponent };